'use strict';

namespace Attractions {

    type AttractionDetails = Core.Booking.AttractionDetails;
    type TripService = Core.TripService;
    type IHttpService = Core.IHttpService;

    angular
        .module('attractions')
        .service('attractionService', attractionService);


    function attractionService($q,
                               $http: IHttpService,
                               tripService: TripService,
                               analytics,
                               dateUtil) {
        var domain = TRPCONFIG.Domain,
            apiUrl = '/api2/attractions',
            service = {
                trackAttractionSearch,
                getProductName,
                getProductFormCriteria,
                getAvailability,
                getProductTotals,
                getLineItemChanges,
                getAttractionQuotes,
                getAttractionQuotesFromSession,
                getOccupancy,
                getLineItemDates,
                getAttractionsDesc
            };

        function getAttractionsDesc(attractions, attractionDetails: AttractionDetails[], id) {
            let desc = '';
            let prefDate = '';
            const product = _.find(attractions,
                (a: any) => a.Details && a.Details.AttractionRequests[id]
            );
            const details = <any>_.find(attractionDetails, {
                ProductId: id
            });

            if (product) {
                const attractionIds = <any[]>_.get(product, 'Details.AttractionIds');
                const i = attractionIds && attractionIds.indexOf(id);
                const cb = product.CostBreakdown;

                if (cb && i != null) {
                    desc = cb[i].Description;
                }
                if (details) {
                    prefDate = dateUtil.format(
                            dateUtil.parseDate(details.PreferredDate)
                        ) + ', ';
                }
            }
            return prefDate + desc;
        };

        function trackAttractionSearch(searchId, itemId, itemName) {
            return $http.post(
                apiUrl + '/analytics/autocompleter/selection',
                {
                    SearchId: searchId,
                    SelectedItemId: itemId,
                    SelectedItemName: itemName
                },
                {ignoreErrors: true}
            );
        }

        function getProductName(productId) {
            return $http.post(
                `${apiUrl}/bookingfunnel/getproduct/${productId}`,
                [],
                {ignoreErrors: true}
            ).then(res => res.data);
        }

        function getProductFormCriteria(productId) {
            return $http.post(
                apiUrl + '/bookingfunnel/getcriteria/' + productId
            ).then(res => res.data);
        }

        function getAvailability(productId, tags) {
            // Standardise date to first of month
            let date = new Date(dateUtil.parseDate(tags.date).getTime());
            date.setDate(1);
            date.setHours(12);

            return $http.post(
                apiUrl + '/bookingfunnel/searchavailability',
                {
                    Id: productId,
                    Tags: angular.extend({}, tags, {date: date}),
                    DomainId: domain.DomainId,
                    Currency: domain.CurrencyCode
                },
                {ignoreErrors: true}
            ).then(
                res => res.data,
                err => ({error: err})
            );
        }

        function getProductTotals(lineItems) {
            let totals = {count: 0, price: 0};
            totals.price = lineItems && lineItems.reduce((total, item) => {
                    if (item.Tickets) {
                        totals.count++;
                        return total + item.Tickets.reduce((t, o) => t + (o.Price * o.Value), 0);
                    }
                }, 0);
            return totals;
        }

        function getLineItemDates(lineItem) {
            const dates = {
                selected: null,
                from: null,
                to: null
            };

            if (lineItem.Description && lineItem.Description.SelectedDate) {
                dates.selected = dateUtil.format(lineItem.Description.SelectedDate);
            }

            const validity = lineItem.Description && lineItem.Description.Validity
                ? lineItem.Description.Validity : null;

            if (validity) {
                const from = dateUtil.format(validity.From);
                const to = dateUtil.format(validity.To);

                if (from && to && !dateUtil.sameDay(validity.From, validity.To)) {
                    dates.from = from;
                    dates.to = to;
                }
            }

            return dates;
        }

        function getLineItemChanges(basketData) {
            // Returns lineItems data indicating basket changes
            let lineItems: any = [],
                changeData = basketData.Change,
                modifiedData = changeData && changeData.Modified || [];

            modifiedData.forEach(modifiedItem => {
                let LineItemId = modifiedItem.LineItemId,
                    basketItem = _.find(basketData.Basket.LineItems, {
                        LineItemId: LineItemId
                    });
                if (basketItem) {
                    lineItems.push(
                        _mergeTicketChanges(basketItem, modifiedItem)
                    );
                }
            });
            return lineItems;
        }

        function _mergeTicketChanges(basketItem, modifiedData) {
            // Merges ticket changes data into basket lineItem data
            // Resulting data indicates ticket changes
            let lineItem = angular.extend({}, basketItem);
            lineItem.Tickets = [];

            ['Modified', 'New'].forEach(modificationType => {
                modifiedData[modificationType].forEach(props => {
                    let basketTicket = _.find(basketItem.Tickets, {
                        Key: props.Key
                    });
                    if (basketTicket) {
                        lineItem.Tickets.push(
                            angular.extend({}, basketTicket, props)
                        );
                    }
                });
            });
            return lineItem;
        }


        /*
         Attractions extras
         */
        function getAttractionQuotes(tripId, request) {
            var req = angular.extend({
                DomainId: domain.DomainId,
                Currency: domain.CurrencyCode
            }, request);
            analytics.startTimer('AttractionsAvailabilityRequest');
            return $http.post(apiUrl + '/availability/GetCrossSell', req, {ignoreErrors: true}).then(function (res) {
                analytics.endTimer('AttractionsAvailabilityRequest');
                tripService.recordAttractionSearch(tripId, request);
                return res.data.AttractionQuotes;
            });
        }

        function getAttractionQuotesFromSession(availabilitySearchId) {
            return $http.post(apiUrl + '/availability/getfromsession', {
                'AvailabilitySearchId': availabilitySearchId
            }, {ignoreErrors: true}).then(function (res) {
                return res.data.AttractionQuotes;
            });
        }

        function getOccupancy(tripId) {
            return tripService.getTripReducedOccupancy(tripId).then(occ => {
                var res: any = [];
                for (var i = 0; i < occ.Adults; i++) {
                    res.push({Age: 21, Type: 'Adult'});
                }
                angular.forEach(occ.ChildAges, function (age) {
                    res.push({
                        Type: age < 2 ? 'Infant' : 'Child',
                        Age: age
                    });
                });
                return res;
            });
        }

        return service;

    }
}
